var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.nodeName)+"\n  "),_c('CopyToClipboard',{staticClass:"icon-btn",attrs:{"text":_vm.nodeName,"label-as":"tooltip","action-color":"bg-transparent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }